import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { openPopup } from "../../../store/popupSlice";
import { BaseUrl } from "../../helper/BaseUrl";

export default function CloneAppBanner({ section1 }) {
  const dispatch = useDispatch();
  return (
    <>
      {section1.url &&
        (<section className="lft-banner">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div class="banner-content">
                  <div className="new-mobility">mobility Infotech</div>

                  <h1 className="heading">{section1.title ? section1.title : ""}</h1>
                  <p>{section1.para ? section1.para : ""}</p>

                  <small>21 Days Free Trial | No Credit Card Required</small>

                  <div className="lyft-banner-btn">
                    <Link style={{ marginRight: "15px" }} className="default-btn animated-btn" onClick={() => dispatch(openPopup())} >
                      schedule a metting
                    </Link>

                    <Link className="default-btn" to={"/features/taxi-dispatch-software"}>
                      features
                    </Link>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="banner-image">
                  <img className="img-responsive" src={`${BaseUrl}${section1 && section1.image}`} alt="logo"/>
                </div>
              </div>
            </div>
          </div>
        </section>)
      }
    </>
  );
}
